/**
 * Pairing resource - /pair endpoints for device pairing
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.PairingResource');
export class PairingResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Generate a new pairing code
     */
    async generateCode() {
        log.debug('Generating pairing code');
        const response = await this.http.post('/pair', {});
        log.info('Pairing code generated', { expiresAt: response.expiresAt });
        return response;
    }
    /**
     * Check pairing status
     */
    async checkStatus(code) {
        log.debug('Checking pairing status', { code });
        const response = await this.http.get(`/pair/${code}`);
        log.debug('Pairing status checked', { code, registered: response.registered });
        return response;
    }
}
//# sourceMappingURL=PairingResource.js.map